import type { ReactNode } from 'react';

import styles from '@/components/book/Page.module.css';

interface PageProps {
  /** `page`: the 1100px frame for lists and indexes. `leaf`: one reading column, 1100px at the reader's default measure. */
  variant?: 'page' | 'leaf';
  /** Shifts the reading column left at 1180px and wider so margin notes fit beside it. */
  hasNotes?: boolean;
  children: ReactNode;
}

/** The page frame every Index Book screen sits in (DESIGN-SPEC §1.10, §2.5). */
export function Page({ variant = 'page', hasNotes = false, children }: PageProps) {
  if (variant === 'page') return <div className={styles.page}>{children}</div>;
  return (
    <div className={styles.leafpage}>
      <article className={[styles.leaf, hasNotes ? styles.notes : ''].filter(Boolean).join(' ')} data-has-notes={hasNotes || undefined}>{children}</article>
    </div>
  );
}
